import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectHolidays } from '../redux/slices/criticalDataSlice';
import { setHolidays } from '../redux/slices/holidaysSlice';

export default function useCalendarHolidaysRealtime(enabled = true) {
  const dispatch = useDispatch();
  const holidays = useSelector(selectHolidays);
  // CriticalDataRealtime owns the network subscription; calendars only mirror
  // its shared snapshot into the legacy slice (including an empty list).
  useEffect(() => {
    if (enabled && Array.isArray(holidays)) dispatch(setHolidays(holidays));
  }, [dispatch, enabled, holidays]);
}
